import { Users, Handshake } from "lucide-react";
import { getPillarById } from "@/data/pillars";
import CalendarBoard from "@/components/CalendarBoard";

const ICONS = { Users, Handshake };

export default function CalendarPage({ pillarId }) {
  const pillar = getPillarById(pillarId);
  const Icon = ICONS[pillar.icon] || Users;

  return (
    <div className="px-5 md:px-8 py-8 max-w-[1500px]" data-testid={`calendar-page-${pillarId}`}>
      <div className="flex items-center gap-2 mb-1">
        <span className="w-3 h-3 rounded-full" style={{ backgroundColor: pillar.color }} />
        <span className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground">{pillar.name}</span>
      </div>
      <h1 className="font-serif text-3xl md:text-4xl text-foreground flex items-center gap-3 mb-2">
        <Icon className="w-7 h-7 text-muted-foreground" strokeWidth={1.5} /> Calendar
      </h1>
      <p className="text-sm text-muted-foreground mb-8 max-w-2xl">
        One shared calendar for Family and Friends. Plan birthdays, recurring and one-time events,
        and toggle each set on or off.
      </p>
      <CalendarBoard />
    </div>
  );
}
